export default "__VITE_ASSET__e8797293__"